import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Chip,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  formatDurationMs,
  isLocatorIgnored,
  statusLabel,
} from '../../../utilities/locatorDrift/locatorFormatters';
import DriftDetail from './DriftDetail';
import { driftTableStyles } from './screenDriftStyles';

export default function DriftTable({
  category,
  allItems,
  expandedIndex,
  setExpandedIndex,
  ignoreList,
  onIgnore,
}) {
  return (
    <Accordion defaultExpanded={category.defaultOpen} disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Chip size="small" color={category.color} label={category.label} />
          <Typography variant="body2" color="text.secondary">
            {category.items.length}
          </Typography>
        </Stack>
      </AccordionSummary>
      <AccordionDetails sx={driftTableStyles.details}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Status</TableCell>
              <TableCell>By</TableCell>
              <TableCell>Locator</TableCell>
              <TableCell>Ver A</TableCell>
              <TableCell>Ver B</TableCell>
              <TableCell>Dur A</TableCell>
              <TableCell>Dur B</TableCell>
              <TableCell>Exception</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {category.items.map((item) => {
              const globalIndex = allItems.indexOf(item);
              const versionA = item.version_a || {};
              const versionB = item.version_b || {};
              const locatorBy = item.locator_by || item.by || '';
              const locatorValue = item.locator_value || item.value || '';
              const isOpen = expandedIndex === globalIndex;
              const ignored = isLocatorIgnored(ignoreList, locatorBy, locatorValue);
              return (
                <React.Fragment key={`${globalIndex}-${locatorValue}`}>
                  <TableRow
                    hover
                    sx={driftTableStyles.clickableRow(ignored)}
                    onClick={() => setExpandedIndex(isOpen ? null : globalIndex)}
                  >
                    <TableCell>
                      <Chip
                        size="small"
                        color={category.color}
                        label={(item.status || item.drift || '').toUpperCase()}
                      />
                    </TableCell>
                    <TableCell>{locatorBy}</TableCell>
                    <TableCell sx={driftTableStyles.locatorCell}>{locatorValue}</TableCell>
                    <TableCell>
                      {versionA.status ? (
                        <Chip
                          size="small"
                          label={statusLabel(versionA.status)}
                          color={versionA.status === 'success' ? 'success' : 'error'}
                        />
                      ) : (
                        '-'
                      )}
                    </TableCell>
                    <TableCell>
                      {versionB.status ? (
                        <Chip
                          size="small"
                          label={statusLabel(versionB.status)}
                          color={versionB.status === 'success' ? 'success' : 'error'}
                        />
                      ) : (
                        '-'
                      )}
                    </TableCell>
                    <TableCell>
                      {formatDurationMs(versionA.duration_ms ?? item.duration_a)}
                    </TableCell>
                    <TableCell>
                      {formatDurationMs(versionB.duration_ms ?? item.duration_b)}
                    </TableCell>
                    <TableCell>
                      {versionB.exception_type ||
                        item.exception_b ||
                        versionA.exception_type ||
                        '-'}
                    </TableCell>
                    <TableCell>
                      {!ignored && (
                        <Button
                          size="small"
                          onClick={(event) => {
                            event.stopPropagation();
                            onIgnore(item);
                          }}
                        >
                          Ignore
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                  {isOpen && (
                    <TableRow>
                      <TableCell colSpan={9} sx={driftTableStyles.detailCell}>
                        <DriftDetail item={item} />
                      </TableCell>
                    </TableRow>
                  )}
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </AccordionDetails>
    </Accordion>
  );
}
